module.exports = __webpack_public_path__ + "img/aba_daag_no.a97d51f1.png";